import { mixin } from "@/mixins/mixin";

export default {
  allWebmail: (state) => {
    return state.webmails
  },
}
